export const haafCollectorConfig = {
  sidebarNav: [
    {
      title: "Overview",
      href: "/haaf-collector/overview",
      icon: "layout-dashboard",
    },
    {
      title: "HAF Payments",
      href: "/haaf-collector/haf-payments",
      icon: "banknote",
    },
    {
      title: "Settings",
      href: "/haaf-collector/settings",
      icon: "settings",
    },
  ],
};
